import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createAction } from 'redux-actions';
export const fetchModulesSuccess = createAction('@@gruser.MODULES.FETCH.SUCCESS', (gruser, modules)=>({
        gruser,
        modules
    }));
export const fetchModuleSuccess = createAction('@@gruser.MODULE.FETCH.SUCCESS', (gruser, payload)=>_object_spread_props(_object_spread({}, payload), {
        gruser
    }));
export const updateModule = createAction('@@gruser.MODULE.UPDATE', (gruser, payload)=>_object_spread_props(_object_spread({}, payload), {
        gruser
    }));
export const fetchModuleEndpoint = createAction('@@gruser.MODULE.ENDPOINT.FETCH', (gruser, payload)=>_object_spread_props(_object_spread({}, payload), {
        gruser
    }));
export const fetchModuleEndpointSuccess = createAction('@@gruser.MODULE.ENDPOINT.FETCH.SUCCESS', (gruser, payload)=>_object_spread_props(_object_spread({}, payload), {
        gruser
    }));
export const fetchModuleEndpointError = createAction('@@gruser.MODULE.ENDPOINT.FETCH.ERROR', (gruser, payload)=>_object_spread_props(_object_spread({}, payload), {
        gruser
    }));
export const fetchModuleEndpointPurgeData = createAction('@@gruser.MODULE.ENDPOINT.PURGE_DATA', (gruser, payload)=>_object_spread_props(_object_spread({}, payload), {
        gruser
    }));
export const purgeAllModules = createAction('@@gruser.MODULE.PURGE.ALL', (gruser)=>({
        gruser
    }));
